<!--<div class="container-fluid pos-fixed fixed-top z-top fg-white gradient-box">
  <app-menu></app-menu>
</div>
<br />
<br />
<div style="width: 100%; padding: 0.5rem">
  <router-outlet></router-outlet>
</div>-->
<div style="width: 100%; padding: 1rem; top: 60px">
  <router-outlet></router-outlet>
</div>
<!--<app-home>
  <div class="proy-fondo">
    <div>
      <div style="margin: 2em auto" data-role="activity" data-type="cycle" data-style="color"></div>
      <span class="text-center d-block" style="font-weight: 500!important">Cargando... Favor, espere</span>
    </div>
    <span class="text-small text-right d-block">Photo by <a href="https://unsplash.com/markuswinkler?utm_source=unsplash&amp;utm_medium=referral&amp;utm_content=creditCopyText">Markus Winkler</a> on <a href="https://unsplash.com/s/photos/project-management?utm_source=unsplash&amp;utm_medium=referral&amp;utm_content=creditCopyText">Unsplash</a></span>
  </div>
</app-home>-->




